<template class="">
  <div class="login">
  <div v-if="isLoading" class="loading">Loading&#8230;</div>



<div class="columns is-gapless is-centered" style="margin-bottom:504em;">

<div class="column box has-background-light" :class="return_column_width('is-6', 'is-9')">

<!-- ************************RESET*************************************
****************************************************************** -->
<div v-if="view_login == 'RESET'" class="columns is-multiline is-gapless" style="padding:4em;margin-top:-1em;">

<div class="column is-12 isLabel">Entrez votre email</div>
<div class="column is-6"> <!-- CELL COLUMN  -->
<div class="columns is-multiline is-gapless">

<div class="column is-12">
  
  <div class="control has-icons-left">
    <input v-model="reset_email" class="input is-fullwidth has-text-weight-semibold has-text-left" placeholder="@ ">
    <span class="icon is-small is-left">
      <i class="fas fa-envelope"></i>
    </span>
  </div>

</div>
</div>
</div><!-- END CELL COLUMN  -->
    
<div class="column is-6"> <!-- RESET BTN COLUMN  -->
<div class="columns is-multiline is-gapless">
<div class="column is-12">
      <button :disabled="!reset_valid" @click="check_reset()" class="button is-warning is-fullwidth">
        Check &nbsp;&nbsp;<span class="icon is-small has-text-left"><i class="fas fa-fish"></i></span> 
      </button>
</div></div>



</div><!-- END RESET BTN COLUMN  -->

<div class="column is-12" style="margin-top:2em;">
<div class="columns is-multiline is-gapless is-centered">
  <div @click="view_login = 'LOGIN'" class="column isLink is-6 has-text-left is-size-7"> Retour connexion </div>
  <div v-if="reset_invalid" class="column is-6 has-text-danger has-text-centered has-text-weight-bold">Email non trouvé</div>
  <div v-if="reset_sent" class="column is-6 has-text-success has-text-centered has-text-weight-bold">Email envoyé</div>
</div> 
</div>







</div>
<!-- ************************RESET*************************************
****************************************************************** -->



<div v-if="view_login == 'LOGIN'" class="columns is-multiline is-gapless" style="padding:4em;margin-top:-1em;">

<div class="column is-6"> <!-- EMAIL COLUMN  -->
<div class="columns is-multiline is-gapless">
<div class="column is-12 isLabel">Email</div>
<div class="column is-12">
  
  <div class="control has-icons-left">
    <input v-model="user_email" type="email" placeholder="e.g. bobsmith@gmail.com" class="input" required>
    <span class="icon is-small is-left">
      <i class="fa fa-envelope"></i>
    </span>
  </div>

</div>
</div>
</div><!-- END EMAIL COLUMN  -->

<div class="column is-6"> <!-- PASSWORD COLUMN  -->
<div class="columns is-multiline is-gapless">
<div class="column is-12 isLabel">Mot de passe</div>
<div class="column is-12">
  <div class="control has-icons-left">
      <input v-model="user_pass" v-on:keyup.enter="chk_login()" type="password" placeholder="*******" class="input" required>
      <span class="icon is-small is-left">
        <i class="fa fa-lock"></i>
      </span>
  </div>

</div>
</div>
</div><!-- END PASSWORD COLUMN  -->

<div class="column is-12" style="margin-top:2em;">
<!-- BUTTONs ROW  -->
  <div class="columns is-multiline is-gapless is-mobile">
  <div @click="show_reset()" class="column is-size-7 colNotes isLink" :class="return_column_width('is-4','is-6')">Réinitialiser le mot de passe</div>
  <div class="column" :class="return_column_width('is-5','is-1')"></div>
  <div class="column" :class="return_column_width('is-3','is-5')">
      <button @click="chk_login()" class="button is-success is-fullwidth">
        Connexion &nbsp;&nbsp;<span class="icon is-small has-text-left"><i class="fas fa-sign-in-alt"></i></span> 
      </button>
  </div>
  </div>
</div>

<div v-if="user_invalid" class="column is-12 has-text-centered has-text-danger"> Les informations d'identification invalides! </div>

<!-- END MAIN COLUMNS  -->
</div></div></div>




<!-- <section class="hero is-fullheight">
  <div class="hero-body">
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-5-tablet is-4-desktop is-3-widescreen">
          <div class="box has-background-light">
            <div class="field">
              <label for="" class="label">Email</label>
              <div class="control has-icons-left">
                <input v-model="user_email" type="email" placeholder="e.g. bobsmith@gmail.com" class="input" required>
                <span class="icon is-small is-left">
                  <i class="fa fa-envelope"></i>
                </span>
              </div>
            </div>
            <div class="field">
              <label for="" class="label">Password</label>
              <div class="control has-icons-left">
                <input v-model="user_pass" v-on:keyup.enter="chk_login()" type="password" placeholder="*******" class="input" required>
                <span class="icon is-small is-left">
                  <i class="fa fa-lock"></i>
                </span>
              </div>
            </div>
            <div class="field">
              <button @click="chk_login()" class="button is-success is-fullwidth">
                Login
              </button>
            <span v-if="user_invalid" class="is-pulled-right has-text-danger"> Invalid Credentials! </span>             
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section> -->



  </div>
</template>

<script>
import axios from 'axios';
import js_logos from '@/assets/js/js_logos.js'

export default {
  name: 'login',
  components: {  },

    data() {
    return {
        isLoading:false ,
        user_email:'',
        user_pass:'',
        user_data:'',
        user_invalid:false,

view_login:'LOGIN',

reset_email:'',
reset_valid:true, 

reset_name : '',
reset_number1 : '',
reset_number2 : '', 

reset_invalid: false,
reset_sent: false,

        }
    },


created() {
// CHECK IF MOBILE !!!!
  if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)   
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
    sessionStorage.setItem('isMobile', true);
  }
},

/* watch: {
  reset_email:function() {
    if (this.reset_email.replace(/\D/g,'').length == 10) {this.reset_valid = true}
  }
}, */





  methods: {
  

check_mobile() {
if (sessionStorage.getItem('isMobile') == 'true') 
  {return true} else {return false} 
},
return_column_width(colD, colM) {
if (sessionStorage.getItem('isMobile') == 'true') 
  {return colM} else {return colD} 
},
return_text_size(sizeD, sizeM) {
if (sessionStorage.getItem('isMobile') == 'true') 
  {return sizeM} else {return sizeD} 
},


// GET ADMINISTRATION DATA -- COMMUNICATION, TRANSMISSION ....
get_admin_data:function(){

    var query = `SELECT * FROM MyMEQ_SCHOOLINFO`
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => {     
        sessionStorage.setItem('email_server', res.data[0].email_server)
    });

},




show_reset:function(){
  this.view_login = "RESET"
},
check_reset:function() {

this.isLoading = true;
//var checkNum = this.reset_email.replace(/\D/g,'')
var query = ` SELECT student_ID, student_fNAME + ' ' + student_lNAME AS student FROM MyMEQ_STUDENT WHERE student_eMail = '` + this.reset_email + `'`
//query += ` (REPLACE(LEFT(SUBSTRING(REPLACE(REPLACE(REPLACE(REPLACE(REPLACE(student_TelOther, '(', ''), ')', ''), '-', ''), ' ', ''), ',', ''), PATINDEX('%[0-9.-]%', REPLACE(REPLACE(REPLACE(REPLACE(REPLACE(student_TelOther, '(', ''), ')', ''), '-', ''), ' ', ''), ',', '')), 8000), PATINDEX('%[^0-9.-]%',  SUBSTRING(REPLACE(REPLACE(REPLACE(REPLACE(REPLACE(student_TelOther, '(', ''), ')', ''), '-', ''), ' ', ''), ',', ''), PATINDEX('%[0-9.-]%',  REPLACE(REPLACE(REPLACE(REPLACE(REPLACE(student_TelOther, '(', ''), ')', ''), '-', ''), ' ', ''), ',', '')), 8000) + 'X') - 1), '.', '') = '` + checkNum +`')`
//query += ` OR (REPLACE(LEFT(SUBSTRING(REPLACE(REPLACE(REPLACE(REPLACE(REPLACE(student_TelHome, '(', ''), ')', ''), '-', ''), ' ', ''), ',', ''), PATINDEX('%[0-9.-]%', REPLACE(REPLACE(REPLACE(REPLACE(REPLACE(student_TelHome, '(', ''), ')', ''), '-', ''), ' ', ''), ',', '')), 8000), PATINDEX('%[^0-9.-]%',  SUBSTRING(REPLACE(REPLACE(REPLACE(REPLACE(REPLACE(student_TelHome, '(', ''), ')', ''), '-', ''), ' ', ''), ',', ''), PATINDEX('%[0-9.-]%',  REPLACE(REPLACE(REPLACE(REPLACE(REPLACE(student_TelHome, '(', ''), ')', ''), '-', ''), ' ', ''), ',', '')), 8000) + 'X') - 1), '.', '') = '` + checkNum + `')`
 
// CHECK CAF STUDENT
axios.get(this.$url+'/query_general_CAF?query=' + encodeURIComponent(query))
.then(res => { if (res.data.length) { this.reset_password_send('/query_general_CAF' ,res.data[0],'CAF') ; return; } 
//CHECK AEQ STUDENT
axios.get(this.$url+'/query_general_AEQ?query=' + encodeURIComponent(query))
.then(res => { if (res.data.length) { this.reset_password_send('/query_general_AEQ' ,res.data[0],'AEQ') ; return; } 
// CHECK ESJ STUDENT
axios.get(this.$url+'/query_general_ESJ?query=' + encodeURIComponent(query))
.then(res => { if (res.data.length) { this.reset_password_send('/query_general_ESJ' ,res.data[0],'ESJQ') ; return; } 

// CHECK MUSI STUDENT
axios.get(this.$url+'/query_general_MUSI?query=' + encodeURIComponent(query))
.then(res => { if (res.data.length) { this.reset_password_send('/query_general_MUSI' ,res.data[0],'MUSI') ; return; } 

// CHECK PORTAL STUDENT
axios.get(this.$url+'/query_general_DEMO?query=' + encodeURIComponent(query))
.then(res => { if (res.data.length) {  this.reset_password_send('/query_general_DEMO' ,res.data[0],'PORTAL') ; return; }

// HERE THEN NOTHING
  this.reset_sent = false
  this.reset_invalid = true
  this.isLoading = false;

          this.$snotify.error('Please contact school administration', 'Email not found' , {
          timeout: 2000,
          showProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          position: "centerTop",
          });



}); }); }); }); });


},
 
reset_password_send:function(connDB, data, school) {
 
var newPass = this.makeid(5)
var msg = 'Hello '+ data.student + '. Your new password : ' + newPass
var msgHTML = 'Hello '+ data.student + '<br /> Your new password : ' + newPass

//alert(this.$url + connDB + '?query=')

    var sql = "UPDATE myMEQ_STUDENT SET student_webPass = '" + newPass + "' WHERE student_ID = " + data.student_ID 
    axios.get(this.$url + connDB + '?query=' + encodeURIComponent(sql))
    .then(res => {
 
    axios.get(this.$url+'/send_email?addresses='+this.reset_email+'&subject='+school+' - password reset&msgText='+msg+'&msgHtml='+msgHTML)
    .then(res => { 
        this.reset_invalid = false
        this.reset_sent = true
        this.isLoading = false;
        this.view_login = 'LOGIN'

          this.$snotify.success('Please check Spam folder as well....','Email Sent' ,  {
          timeout: 2000,
          showProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          position: "centerTop",
          });


    })
})

},

makeid:function(length) {
   var result           = '';
   var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
   var charactersLength = characters.length;
   for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
   }
   return result;
},




    chk_login:function () {


    if (!this.user_email) {this.user_invalid=true;return;}
    if (!this.user_pass) {this.user_invalid=true;return;}



this.isLoading = true;
var query = "select  * from myMEQ_STUDENT WHERE student_eMail='"+escape(this.user_email)+"' AND student_webPass='"+escape(this.user_pass)+"'";
var queryProf = "select  * from myMEQ_STAFF WHERE staff_Email='"+escape(this.user_email)+"' AND staff_PASSWORD='"+escape(this.user_pass)+"'";

// CHECK CAF STUDENT

// console.log(query)

axios.get(this.$url+'/query_general_CAF?query=' + query)
.then(res => {
  if (res.data.length) {
    sessionStorage.setItem('user_ID', res.data[0].student_ID)  
    sessionStorage.setItem('user_name', res.data[0].student_fNAME + ' ' + res.data[0].student_lNAME)
    sessionStorage.setItem('isGood', 'GOOD')
    sessionStorage.setItem('user_level', 'STUD')
    sessionStorage.setItem('college', 'Le Collège April-Fortier')
    sessionStorage.setItem('college_nickname', 'CAF')
    sessionStorage.setItem('url_query', '/query_general_CAF')
    this.$router.push({ name: 'student_main' });
    this.isLoading = false;
    return; 

} else { // ----------------------------------------> CHECK CAF STAFF
      axios.get(this.$url+'/query_general_CAF?query=' + queryProf)
      .then(res => {
        if (res.data.length) {
          sessionStorage.setItem('user_ID', res.data[0].staff_ID)
          sessionStorage.setItem('user_name', res.data[0].staff_Prenom + ' ' + res.data[0].staff_Nom)
          sessionStorage.setItem('isGood', 'GOOD')
          sessionStorage.setItem('user_level', res.data[0].staff_Type)
          sessionStorage.setItem('user_email', res.data[0].staff_Email)
          sessionStorage.setItem('college', 'Le Collège April-Fortier')
          sessionStorage.setItem('college_nickname', 'CAF')
          sessionStorage.setItem('college_code', '749720')
          sessionStorage.setItem('url_query', '/query_general_CAF')
          sessionStorage.setItem('url_query_form', '/query_general_CAF_form')

// LOGO
sessionStorage.setItem('logo',js_logos.return_logo_caf())


          sessionStorage.setItem('sql_prof', '')
          if (res.data[0].staff_Type == 'PROF')
          { sessionStorage.setItem('sql_prof', ' AND (MyMEQ_GROUP.staff_ID_1 = ' + res.data[0].staff_ID + ' OR MyMEQ_GROUP.staff_ID_2 = ' + res.data[0].staff_ID + ')' )} 

          this.$router.push({ name: 'groups' })
          this.isLoading = false;
          return; 


  } else {
    //CHECK AEQ STUDENT
      axios.get(this.$url+'/query_general_AEQ?query=' + query)
      .then(res => {
        if (res.data.length) {
          sessionStorage.setItem('user_ID', res.data[0].student_ID)
          sessionStorage.setItem('user_name', res.data[0].student_fNAME + ' ' + res.data[0].student_lNAME)
          sessionStorage.setItem('isGood', 'GOOD')
          sessionStorage.setItem('user_level', 'STUD')
          sessionStorage.setItem('college', "Académie De L'Entrepreneurship")
          sessionStorage.setItem('college_nickname', 'AEQ')
          sessionStorage.setItem('url_query', '/query_general_AEQ')
          this.$router.push({ name: 'student_main' });
          this.isLoading = false;
          return; 

} else { // ----------------------------------------> CHECK AEQ STAFF
      axios.get(this.$url+'/query_general_AEQ?query=' + queryProf)
      .then(res => {
        if (res.data.length) {
          sessionStorage.setItem('user_ID', res.data[0].staff_ID)
          sessionStorage.setItem('user_name', res.data[0].staff_Prenom + ' ' + res.data[0].staff_Nom)
          sessionStorage.setItem('isGood', 'GOOD')
          sessionStorage.setItem('user_level', res.data[0].staff_Type)
          sessionStorage.setItem('user_email', res.data[0].staff_Email)
          sessionStorage.setItem('college', "Académie De L'Entrepreneurship")
          sessionStorage.setItem('college_nickname', 'AEQ') 
          sessionStorage.setItem('college_code', '294901') 
          // sessionStorage.setItem('college_canEMAIL', '1') // HOLD IF COLLEGE CAN EMAIL / SMS
          sessionStorage.setItem('url_query', '/query_general_AEQ')
          sessionStorage.setItem('url_query_form', '/query_general_AEQ_form')

var collegeInfo = "Académie De L'Entrepreneurship"
collegeInfo += "|4660 Montée Saint-Hubert #104"
collegeInfo += "|Saint-Hubert, QC"
collegeInfo += "|J3Y 1V1"
collegeInfo += "|294901"
sessionStorage.setItem('collegeInfo',collegeInfo)

// LOGO
sessionStorage.setItem('logo',js_logos.return_logo_aeq())


          sessionStorage.setItem('sql_prof', '')
          if (res.data[0].staff_Type == 'PROF')
          { sessionStorage.setItem('sql_prof', ' AND (MyMEQ_GROUP.staff_ID_1 = ' + res.data[0].staff_ID + ' OR MyMEQ_GROUP.staff_ID_2 = ' + res.data[0].staff_ID + ')' )} 

          this.$router.push({ name: 'groups' })
          this.isLoading = false;
          return; 

        } else {

// CHECK AIR STUDENT
      axios.get(this.$url+'/query_general_AIR?query=' + query)
      .then(res => {
        if (res.data.length) {
          sessionStorage.setItem('user_ID', res.data[0].student_ID)
          sessionStorage.setItem('user_name', res.data[0].student_fNAME + ' ' + res.data[0].student_lNAME)
          sessionStorage.setItem('isGood', 'GOOD')
          sessionStorage.setItem('user_level', 'STUD')
          sessionStorage.setItem('college', "CARGAIR")
          sessionStorage.setItem('college_nickname', 'AIR')
          sessionStorage.setItem('url_query', '/query_general_AIR')
          this.$router.push({ name: 'student_main' });
          this.isLoading = false;
          return; 

} else { // ----------------------------------------> CHECK AIR STAFF
      axios.get(this.$url+'/query_general_AIR?query=' + queryProf)
      .then(res => {
        if (res.data.length) {
          sessionStorage.setItem('user_ID', res.data[0].staff_ID)
          sessionStorage.setItem('user_name', res.data[0].staff_Prenom + ' ' + res.data[0].staff_Nom)
          sessionStorage.setItem('isGood', 'GOOD')
          sessionStorage.setItem('user_level', res.data[0].staff_Type)
          sessionStorage.setItem('user_email', res.data[0].staff_Email)
          sessionStorage.setItem('college', "CARGAIR")
          sessionStorage.setItem('college_nickname', 'AIR')
          sessionStorage.setItem('college_code', '693651')
          sessionStorage.setItem('url_query', '/query_general_AIR')
          sessionStorage.setItem('url_query_form', '/query_general_AIR_form')
          // LOGO
          sessionStorage.setItem('logo',js_logos.return_logo_air())

          sessionStorage.setItem('sql_prof', '')
          if (res.data[0].staff_Type == 'PROF')
          { sessionStorage.setItem('sql_prof', ' AND (MyMEQ_GROUP.staff_ID_1 = ' + res.data[0].staff_ID + ' OR MyMEQ_GROUP.staff_ID_2 = ' + res.data[0].staff_ID + ')' )} 

          this.$router.push({ name: 'groups' });
          this.isLoading = false;
          return; 

 

        } else {

// CHECK ESJ STUDENT
      axios.get(this.$url+'/query_general_ESJ?query=' + query)
      .then(res => {
        if (res.data.length) {
          sessionStorage.setItem('user_ID', res.data[0].student_ID)
          sessionStorage.setItem('user_name', res.data[0].student_fNAME + ' ' + res.data[0].student_lNAME)
          sessionStorage.setItem('isGood', 'GOOD')
          sessionStorage.setItem('user_level', 'STUD')
          sessionStorage.setItem('college', "École De Sténographie Judiciaire")
          sessionStorage.setItem('college_nickname', 'ESJQ')
          sessionStorage.setItem('url_query', '/query_general_ESJ')
          this.$router.push({ name: 'student_main' });
          this.isLoading = false;
          return; 

} else { // ----------------------------------------> CHECK ESJQ STAFF
      axios.get(this.$url+'/query_general_ESJ?query=' + queryProf)
      .then(res => {
        if (res.data.length) {
          sessionStorage.setItem('user_ID', res.data[0].staff_ID)
          sessionStorage.setItem('user_name', res.data[0].staff_Prenom + ' ' + res.data[0].staff_Nom)
          sessionStorage.setItem('isGood', 'GOOD')
          sessionStorage.setItem('user_level', res.data[0].staff_Type)
          sessionStorage.setItem('user_email', res.data[0].staff_Email)
          sessionStorage.setItem('college', "École De Sténographie Judiciaire")
          sessionStorage.setItem('college_nickname', 'ESJQ')
          sessionStorage.setItem('college_code', '692580')
          sessionStorage.setItem('url_query', '/query_general_ESJ')
          sessionStorage.setItem('url_query_form', '/query_general_ESJ_form')
          // LOGO
          sessionStorage.setItem('logo',js_logos.return_logo_esjq())

          sessionStorage.setItem('sql_prof', '')
          if (res.data[0].staff_Type == 'PROF')
          { sessionStorage.setItem('sql_prof', ' AND (MyMEQ_GROUP.staff_ID_1 = ' + res.data[0].staff_ID + ' OR MyMEQ_GROUP.staff_ID_2 = ' + res.data[0].staff_ID + ')' )} 

          this.$router.push({ name: 'groups' });
          this.isLoading = false;
          return; 

        } else {

// CHECK PORTAL STUDENT
      axios.get(this.$url+'/query_general_DEMO?query=' + query)
      .then(res => {
        if (res.data.length) {
          sessionStorage.setItem('user_ID', res.data[0].student_ID)
          sessionStorage.setItem('user_name', res.data[0].student_fNAME + ' ' + res.data[0].student_lNAME)
          sessionStorage.setItem('isGood', 'GOOD')
          sessionStorage.setItem('user_level', 'STUD')
          sessionStorage.setItem('college', "École De DEMO")
          sessionStorage.setItem('college_nickname', 'EDD')
          sessionStorage.setItem('url_query', '/query_general_DEMO')
          this.$router.push({ name: 'student_main' });
          this.isLoading = false;
          return; 

} else { // ----------------------------------------> CHECK PORTAL STAFF
      axios.get(this.$url+'/query_general_DEMO?query=' + queryProf)
      .then(res => {
        if (res.data.length) {
          sessionStorage.setItem('user_ID', res.data[0].staff_ID)
          sessionStorage.setItem('user_name', res.data[0].staff_Prenom + ' ' + res.data[0].staff_Nom)
          sessionStorage.setItem('isGood', 'GOOD')
          sessionStorage.setItem('user_level', res.data[0].staff_Type)
          sessionStorage.setItem('user_email', res.data[0].staff_Email)
          sessionStorage.setItem('college', "École De DEMO")
          sessionStorage.setItem('college_nickname', 'EDD')
          sessionStorage.setItem('college_code', '749841')
          // sessionStorage.setItem('college_canEMAIL', '1')
          sessionStorage.setItem('college_canSMS', '1')
          sessionStorage.setItem('url_query', '/query_general_DEMO')
          sessionStorage.setItem('url_query_form', '/query_general_DEMO_form')


var collegeInfo = "École de Demo"
collegeInfo += "|465, rue Here, bureau 505"
collegeInfo += "|Montréal, QC"
collegeInfo += "|H2Y 2R6"
collegeInfo += "|414141"
sessionStorage.setItem('collegeInfo',collegeInfo)


          sessionStorage.setItem('sql_prof', '')
          if (res.data[0].staff_Type == 'PROF')
          { sessionStorage.setItem('sql_prof', ' AND (MyMEQ_GROUP.staff_ID_1 = ' + res.data[0].staff_ID + ' OR MyMEQ_GROUP.staff_ID_2 = ' + res.data[0].staff_ID + ')' )} 

// LOGO
sessionStorage.setItem('logo',js_logos.return_logo_musi())

// GET ADMIN DATA ....
// this.get_admin_data()
    var query = `SELECT * FROM MyMEQ_SCHOOLINFO`
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => {     
          sessionStorage.setItem('email_server', res.data[0].email_server)
          sessionStorage.setItem('email_username', res.data[0].email_username)
          sessionStorage.setItem('email_password', res.data[0].email_password)
          sessionStorage.setItem('sms_number', res.data[0].sms_number)
          sessionStorage.setItem('sms_api', res.data[0].sms_api)          

          this.$router.push({ name: 'groups' });
          this.isLoading = false;
          return; 

    });







       } else {



 query = "select  * from myMEQ_STUDENT WHERE student_eMail='"+escape(this.user_email)+"' AND student_webPass='"+escape(this.user_pass)+"'";
 queryProf = "select  * from myMEQ_STAFF WHERE staff_Email='"+escape(this.user_email)+"' AND staff_PASSWORD='"+escape(this.user_pass)+"'";

// CHECK PORTAL STUDENT
      axios.get(this.$url+'/query_general_MUSI?query=' + query)
      .then(res => {
        if (res.data.length) {

          sessionStorage.setItem('user_ID', res.data[0].student_ID)
          sessionStorage.setItem('user_name', res.data[0].student_fNAME + ' ' + res.data[0].student_lNAME)
          sessionStorage.setItem('isGood', 'GOOD')
          sessionStorage.setItem('user_level', 'STUD')
          sessionStorage.setItem('college', "Musitechnic")
          sessionStorage.setItem('college_nickname', 'MUSI')
          sessionStorage.setItem('url_query', '/query_general_MUSI')
          this.$router.push({ name: 'student_main' });
          this.isLoading = false;
          return; 

} else { // ----------------------------------------> CHECK PORTAL STAFF
      axios.get(this.$url+'/query_general_MUSI?query=' + queryProf)
      .then(res => {
        if (res.data.length) {
          sessionStorage.setItem('user_ID', res.data[0].staff_ID)
          sessionStorage.setItem('user_name', res.data[0].staff_Prenom + ' ' + res.data[0].staff_Nom)
          sessionStorage.setItem('isGood', 'GOOD')
          sessionStorage.setItem('user_level', res.data[0].staff_Type)
          sessionStorage.setItem('user_email', res.data[0].staff_Email)
          sessionStorage.setItem('college', "Musitechnic")
          sessionStorage.setItem('college_nickname', 'MUSI')
          sessionStorage.setItem('college_code', '749841')
          // sessionStorage.setItem('college_canEMAIL', '1')
          sessionStorage.setItem('college_canSMS', '1')
          sessionStorage.setItem('url_query', '/query_general_MUSI')
          sessionStorage.setItem('url_query_form', '/query_general_MUSI_form')
 

var collegeInfo = "            1088 Clark St"
collegeInfo += "|            Montreal, QC, H2Z 1K2"
collegeInfo += "|....."
collegeInfo += "|....."
collegeInfo += "|749841"
sessionStorage.setItem('collegeInfo',collegeInfo)




// LOGO
sessionStorage.setItem('logo',js_logos.return_logo_musi())



          sessionStorage.setItem('sql_prof', '')
          if (res.data[0].staff_Type == 'PROF')
          { sessionStorage.setItem('sql_prof', ' AND (MyMEQ_GROUP.staff_ID_1 = ' + res.data[0].staff_ID + ' OR MyMEQ_GROUP.staff_ID_2 = ' + res.data[0].staff_ID + ')' )} 


          this.$router.push({ name: 'groups' });
          this.isLoading = false;
          return; 


 } else { // ----------------------------------------> RAC !!!! !!!! !!!!
      axios.get(this.$url+'/query_general_RAC?query=' + queryProf)
      .then(res => {
        if (res.data.length) {
          sessionStorage.setItem('user_ID', res.data[0].staff_ID)
          sessionStorage.setItem('user_name', res.data[0].staff_Prenom + ' ' + res.data[0].staff_Nom)
          sessionStorage.setItem('isGood', 'GOOD')
          sessionStorage.setItem('user_level', res.data[0].staff_Type)
          sessionStorage.setItem('user_email', res.data[0].staff_Email)
          sessionStorage.setItem('college', "Recording Arts Canada")
          sessionStorage.setItem('college_nickname', 'RAC')
          sessionStorage.setItem('college_code', '359505')
          sessionStorage.setItem('url_query', '/query_general_RAC')
          sessionStorage.setItem('url_query_form', '/query_general_RAC_form')
          // LOGO
          sessionStorage.setItem('logo',js_logos.return_logo_esjq())

          sessionStorage.setItem('sql_prof', '')
          if (res.data[0].staff_Type == 'PROF')
          { sessionStorage.setItem('sql_prof', ' AND (MyMEQ_GROUP.staff_ID_1 = ' + res.data[0].staff_ID + ' OR MyMEQ_GROUP.staff_ID_2 = ' + res.data[0].staff_ID + ')' )} 

          this.$router.push({ name: 'groups' });
          this.isLoading = false;
          return; 

 } else { // ----------------------------------------> mtc !!!! !!!! !!!!
      axios.get(this.$url+'/query_general_MTC?query=' + queryProf)
      .then(res => {
        if (res.data.length) {
          sessionStorage.setItem('user_ID', res.data[0].staff_ID)
          sessionStorage.setItem('user_name', res.data[0].staff_Prenom + ' ' + res.data[0].staff_Nom)
          sessionStorage.setItem('isGood', 'GOOD')
          sessionStorage.setItem('user_level', res.data[0].staff_Type)
          sessionStorage.setItem('user_email', res.data[0].staff_Email)
          sessionStorage.setItem('college', "Montreal Technical College")
          sessionStorage.setItem('college_nickname', 'MTC')
          sessionStorage.setItem('college_code', '749761')
          sessionStorage.setItem('url_query', '/query_general_MTC')
          sessionStorage.setItem('url_query_form', '/query_general_MTC_form')
          // LOGO
          sessionStorage.setItem('logo',js_logos.return_logo_esjq())

          sessionStorage.setItem('sql_prof', '')
          if (res.data[0].staff_Type == 'PROF')
          { sessionStorage.setItem('sql_prof', ' AND (MyMEQ_GROUP.staff_ID_1 = ' + res.data[0].staff_ID + ' OR MyMEQ_GROUP.staff_ID_2 = ' + res.data[0].staff_ID + ')' )} 

          this.$router.push({ name: 'groups' });
          this.isLoading = false;
          return; 

      } else {

          this.user_invalid = true; 
          this.isLoading = false;
        }

})  // END CHECK 
   } 

})  // END CHECK 
   } 

})  // END CHECK 
   } 

})  // END CHECK 
   } 

})  // END CHECK 
   } 

})  // END CHECK 
   } 
})  // END CHECK 
   } 
})  // END CHECK 
   }     
})  // END CHECK   
  }
}) // END CHECK 
  }
}) // END CHECK

  }
}) // END CHECK
  }
}) // END CHECK

  }
}) // END CHECK

      // CHECK CAF STUDENT
/*     axios.get(this.$url+'/login_student?college=CAF&uid=' + escape(this.user_email) + '&pass=' + escape(this.user_pass))
    .then(res => {
      if (res.data.length) {
          sessionStorage.setItem('user_ID', res.data[0].student_ID)
          sessionStorage.setItem('isGood', 'GOOD')
          sessionStorage.setItem('user_level', 'STUD')
          this.$router.push({ name: 'student_main' });
          return;
      } else {
        // CHECK CAF STAFF
        axios.get(this.$url+'/login_staff?college=CAF&uid=' + escape(this.user_email) + '&pass=' + escape(this.user_pass))
        .then(res => {
          if (res.data.length) {
              sessionStorage.setItem('user_ID', res.data[0].staff_ID)
              sessionStorage.setItem('isGood', 'GOOD')
              sessionStorage.setItem('user_level', res.data[0].staff_Type)
              this.$router.push({ name: 'main' });
              return;
          }  else {
              // CHECK AEQ STUDENT
              axios.get(this.$url+'/login_student?college=AEQ&uid=' + escape(this.user_email) + '&pass=' + escape(this.user_pass))
              .then(res => {
                if (res.data.length) {
                    sessionStorage.setItem('user_ID', res.data[0].student_ID)
                    sessionStorage.setItem('isGood', 'GOOD')
                    sessionStorage.setItem('user_level', 'STUD')
                    this.$router.push({ name: 'student_main' });
                    return;
                }  else {
                    // CHECK AEQ STAFF
                    axios.get(this.$url+'/login_staff?college=AEQ&uid=' + escape(this.user_email) + '&pass=' + escape(this.user_pass))
                    .then(res => {
                      if (res.data.length) {
                          sessionStorage.setItem('user_ID', res.data[0].staff_ID)
                          sessionStorage.setItem('isGood', 'GOOD')
                          sessionStorage.setItem('user_level', res.data[0].staff_Type)
                          this.$router.push({ name: 'main' });
                          return;
                      }
                  })
                }
            })
          }
        })
      }
  })
    this.user_invalid=true // IF HERE -- NO GOOD */
}, // END LOGIN
    








  }, // END METHODS


}
</script>

<style scoped>



</style>